import {
  __HttpRequestModel__,
  HttpRequestModelType,
} from 'shared/domain/httpRequest/httpRequestModel';
import type {
  AbortUploadDetail,
  FileServicesUnion,
} from 'shared/domain/messages/httpQueue/eventMessages';
import { Services } from 'shared/domain/messages/message';

/** Queue entity type of the upload of a file of the service. */
export function toUploadEntityType(type: FileServicesUnion): HttpRequestModelType {
  return type === Services.DOCUMENTS ? HttpRequestModelType.document : HttpRequestModelType.documentation;
}

/** Whether the queued request uploads the file the page dropped. */
export function isUploadOf(
  request: Pick<__HttpRequestModel__, 'method' | 'entityType' | 'data'>,
  { localId, type }: AbortUploadDetail
): boolean {
  return (
    request.method === 'POST' &&
    request.entityType === toUploadEntityType(type) &&
    request.data.localId === localId
  );
}
